import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import sv from "./locales/sv.json";
import de from "./locales/de.json";
import nl from "./locales/nl.json";
import fr from "./locales/fr.json";

export const LANGS = ["en", "sv", "de", "nl", "fr"];

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    sv: { translation: sv },
    de: { translation: de },
    nl: { translation: nl },
    fr: { translation: fr },
  },
  lng: "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
  returnObjects: true,
});

export default i18n;
